// jQuery
import $ from 'jquery'

$.ui = $.ui || {}

window.$ = $
window.jQuery = $

// Leaflet
import L from 'leaflet'
window.L = L

// Buffer
import Buffer from 'buffer'
window.Buffer = Buffer